import { render, staticRenderFns } from "./upload-files.vue?vue&type=template&id=238c282a&scoped=true"
import script from "./upload-files.vue?vue&type=script&lang=js"
export * from "./upload-files.vue?vue&type=script&lang=js"
import style0 from "./upload-files.vue?vue&type=style&index=0&id=238c282a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238c282a",
  null
  
)

export default component.exports